import React from 'react';
import { Link } from 'react-router-dom';
import { DEFAULT_LOCAL_PATH } from '../../../constents';

function ComCurtainSingleThread({ altClas, data, type }) {
  return (
    <div>
      <div className={`left com-curtn-bdy-rw ${altClas}`}>
        <span className="left com-curtn-frm width100">
          From: {data?.fromName}
        </span>
        {type === '3' && (
          <span className="left com-curtn-to width100">
            To: {data?.to_name}
          </span>
        )}
        {(type === '1' || type === '2') && (
          <>
            {data?.chartNo && (
              <span className="txt-thread-chrt">
                ID: {data?.chartNo}
                {data?.dob ? `, DOB: ${data?.dob}` : ``}
              </span>
            )}
            <span className="left com-curtn-to width100">
              To: {data?.toName}
            </span>
          </>
        )}
        <span className="left com-curtn-dt width100">
          {data?.msgSentReceiveTime}
        </span>
        <span className="left com-curtn-msg width100">{data?.content}</span>
        {type === '3' &&
          data?.attachedPatient &&
          data?.attachedPatient[data?.msgId] && (
            <div className="comm-centre-thread-msg user-attachment grid-sec intra-thrd-atchnt-sec">
              {data?.attachedPatient &&
                data?.attachedPatient[data?.msgId]?.map((item, i) => {
                  return (
                    <div className="flex-sec intra-thrd-ptn-sec" key={i}>
                      <span className="com-stf-atchmt-ptnt-lbl sec-colr">
                        {i === 0 && 'Patient:'}
                      </span>

                      <span className="clear-right10 hide">
                        {item?.attachPatPic ? (
                          <img
                            src={item?.attachPatPic}
                            width="30px"
                            height="30px"
                            alt={item?.patShortName}
                            className="com-usr-pic hide"
                          />
                        ) : (
                          <div className="hide">{item?.patShortName}</div>
                        )}
                      </span>
                      <span className="grid-sec">
                        <span className="">
                          <Link
                            to={`${DEFAULT_LOCAL_PATH}/patient/counNote/${item?.attachPatId}`}
                          >
                            {item?.patFullName}
                          </Link>
                        </span>
                        <span className="sec-colr fontsize12">
                          ID:{' '}
                          {item?.attachPatChartNo
                            ? item?.attachPatChartNo.toUpperCase()
                            : ''}
                          , DOB: {item?.attachPatDob} | M:{item?.attachPatMob}
                        </span>
                      </span>
                    </div>
                  );
                })}
            </div>
          )}

        {data?.attachmentList && data?.attachmentList[data?.msgId] && (
          <div className="comm-centre-thread-msg user-attachment flex-sec">
            <span className="com-stf-atchmt-ptnt-lbl sec-colr">
              Attachments:
            </span>
            <ol className="grid-sec clear-left20">
              {data?.attachmentList &&
                data?.attachmentList[data?.msgId]?.map((item, i) => {
                  return (
                    <li key={i} className="clear-right10">
                      <span key={i} className="clear-right5">
                        <a
                          href={item[0]}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {item[1]}
                        </a>
                      </span>
                    </li>
                  );
                })}
            </ol>
          </div>
        )}
      </div>
    </div>
  );
}

export default ComCurtainSingleThread;
